<!-- Hyper help-box: already hidden by the theme in condensed / compact / sm-hover sidebar modes -->
@if (visible) {
<div class="help-box mobile-app-promo text-white text-center mt-3">
  <!-- Above the stretched-link overlay (z-2): it only hides the card and never opens the modal -->
  <button type="button" class="close-btn btn btn-link text-white p-1 lh-1 z-2"
    [attr.aria-label]="'layout.mobileAppPromo.dismiss' | translate"
    [attr.title]="'layout.mobileAppPromo.dismiss' | translate" (click)="dismiss()">
    <i class="ri-close-line font-18" aria-hidden="true"></i>
  </button>
  <img src="assets/images/v2/svg/mobile-app-promo.svg" class="img-fluid" width="170" height="119" alt="" />
  <p class="h5 text-white mt-2 mb-1">{{ 'layout.mobileAppPromo.title' | translate }}</p>
  <p class="font-13 mb-2">{{ 'layout.mobileAppPromo.description' | translate }}</p>
  <!-- stretched-link makes the whole card clickable; data-bs-theme="light" keeps btn-light light on the dark-theme card -->
  <button type="button" class="btn btn-light btn-sm stretched-link" data-bs-theme="light" aria-haspopup="dialog"
    (click)="openModal()">
    <i class="ri-download-2-line me-1" aria-hidden="true"></i>{{ 'layout.mobileAppPromo.cta' | translate }}
  </button>
</div>
}
